import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  table: {
    minWidth: 450
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2)
  },
  metaDataType: {
    fontSize: "13",
    opacity: "0.5"
  },
  metaValueMinWidth: {
    minWidth: "50%"
  },
  metaDeleteBottomWidth: {
    width: "0%"
  },
  metaToolbar: {
    alignItems: "flex-end",
    flexDirection: "column",
    paddingLeft: "16px",
    paddingRight: "16px",
    minHeight: "35px"
  },
  addAttributeButton: {
    position: "absolute",
    top: 0,
    right: 0
  },
  attributeDataType: { fontSize: "13", opacity: "0.5" }
}));

export default useStyles;
